import React, { useEffect, useState } from 'react';
import { Divider, Form, Input, Row, Tabs, Switch } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import federalTaxNumberValidator from 'util/validators/federalTaxNumberValidator';
import { AddressV2 } from 'components';
import ResCol from 'components/forms/ResCol';
import { useSelector } from 'react-redux';
import {
  DrawerEdit,
  FormItemWrap,
  ResourceEdit,
  useCrudEditContext,
  api
} from '@unicus/react-ui-kit';
import { cityNormalizeToSelect } from 'util/normalizers';

const { TabPane } = Tabs;

const CompanyEditInternal = (props) => {
  const { form } = useCrudEditContext();
  const { data = {}, loadingEdition } = props;
  const [image, setImage] = useState(data?.profileImage);
  const [isCompany, setIsCompany] = useState(data.isLegalPerson ?? false);

  const [state, setState] = useState({
    lastFederalTaxNumber: null,
    loadingAddress: false
  });

  const handleBeforeSubmit = ({ ...rest }) => {
    return {
      ...data,
      ...rest,
      profileImage: image
    };
  };

  useEffect(() => {
    if (!loadingEdition) {
      setImage(data?.profileImage);
    }
  }, [loadingEdition]);

  const handleBeforeBinding = ({ settings, ...rest }) => {
    return {
      ...rest
    };
  };

  const setCompanyData = ({
    address,
    legalName,
    stateTaxNumber,
    cityTaxNumber,
    name
  }) => {
    form.setFieldsValue({
      name,
      cityTaxNumber,
      stateTaxNumber,
      legalName,
      address: {
        ...address,
        city: cityNormalizeToSelect(address.city)
      }
    });
  };

  const findCompany = (federalTaxNumber) => {
    federalTaxNumber = federalTaxNumber.replace(/\D/g, '');
    setState({
      ...state,
      lastFederalTaxNumber: federalTaxNumber,
      loadingAddress: true
    });
    api.get('companies/find', federalTaxNumber).then(({ data }) => {
      setState({ ...state, loadingAddress: false });
      setCompanyData(data ? data.result : { address: {} });
    });
  };

  const postalCodeChangeHandle = (sender) => {
    const federalTaxNumber = sender.target.value.replace(/\D/g, '');
    if (federalTaxNumber.length === 14) {
      findCompany(federalTaxNumber);
    }
  };

  const handleSubmit = (submittedValues) => {
    const values = handleBeforeSubmit(submittedValues);

    // if (!data?.id) {
    //   dispatch(postCompany(user.id, values, handleSuccess));
    // } else {
    //   dispatch(putCompany(values, handleSuccess));
    // }
  };

  const toggler = () => {
    if (isCompany) {
      setIsCompany(false);
      return;
    }

    setIsCompany(true);
  };

  return (
    <DrawerEdit
      {...props}
      submit={handleSubmit}
      onBeforeBinding={handleBeforeBinding}
      size="md"
      preserve
    >
      <Form layout="vertical">
        <Tabs className="gx-p-1">
          <TabPane tab="Dados" key="data" forceRender>
            {isCompany ? (
              <>
                <Row gutter={[10, 0]}>
                  <ResCol span={5}>
                    <FormItemWrap label="Pessoa Física">
                      <Switch checked={!isCompany} onChange={toggler} />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={8}>
                    <FormItemWrap
                      label="CNPJ"
                      name="federalTaxNumber"
                      whitespace
                      autoFocus
                      validateTrigger="onBlur"
                      rules={[{ validator: federalTaxNumberValidator }]}
                    >
                      <MaskedInput
                        onChange={postalCodeChangeHandle}
                        mask="11.111.111/1111-11"
                      />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={11}>
                    <FormItemWrap
                      label="Nome fantasia"
                      name="name"
                      required
                      whitespace
                    >
                      <Input maxLength={100} />
                    </FormItemWrap>
                  </ResCol>
                </Row>
                <Row gutter={[10, 0]}>
                  <ResCol span={12}>
                    <FormItemWrap
                      label="Razão Social"
                      name="legalName"
                      required
                      whitespace
                    >
                      <Input />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={6}>
                    <FormItemWrap label="Insc Estadual" name="stateTaxNumber">
                      <Input />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={6}>
                    <FormItemWrap label="Insc Municipal" name="cityTaxNumber">
                      <Input />
                    </FormItemWrap>
                  </ResCol>
                </Row>
              </>
            ) : (
              <>
                <Row className="no-padding-last">
                  <ResCol span={5}>
                    <FormItemWrap label="Pessoa Física">
                      <Switch checked={!isCompany} onChange={toggler} />
                    </FormItemWrap>
                  </ResCol>

                  <ResCol span={13}>
                    <FormItemWrap
                      label="CPF"
                      name="federalTaxNumber"
                      whitespace
                      autoFocus
                      validateTrigger="onBlur"
                      rules={[{ validator: federalTaxNumberValidator }]}
                    >
                      <MaskedInput
                        mask="111.111.111-11"
                        placeholder="___.___.___-__"
                      />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={6}>
                    <FormItemWrap label="Insc Municipal" name="cityTaxNumber">
                      <Input />
                    </FormItemWrap>
                  </ResCol>
                </Row>

                <FormItemWrap label="Nome" name="name" required whitespace>
                  <Input maxLength={100} />
                </FormItemWrap>
              </>
            )}
            <Row gutter={[10, 0]}>
              <ResCol span={12}>
                <FormItemWrap
                  validateTrigger="onBlur"
                  label="Email"
                  name="email"
                  type="email"
                >
                  <Input />
                </FormItemWrap>
              </ResCol>
              <ResCol span={6}>
                <FormItemWrap label="Telefone fixo" name="phone" type="phone">
                  <MaskedInput
                    mask="(11) 1111-1111"
                    placeholder="(__) _____-____"
                  />
                </FormItemWrap>
              </ResCol>
              <ResCol span={6}>
                <FormItemWrap
                  label="Celular"
                  name="mobilePhone"
                  type="mobilePhone"
                >
                  <MaskedInput
                    mask="(11) 11111-1111"
                    placeholder="(__) _____-____"
                  />
                </FormItemWrap>
              </ResCol>
            </Row>
            <Divider orientation="left">Endereço</Divider>
            <AddressV2 required={isCompany} />
          </TabPane>
        </Tabs>
      </Form>
    </DrawerEdit>
  );
};

const CompanyEdit = (props) => {
  const { userCompany, saving } = useSelector((c) => c.resources.users ?? {});
  const { uploading } = useSelector((c) => c.resources.companies ?? {});

  if (!userCompany) {
    return null;
  }

  return (
    <CompanyEditInternal
      {...props}
      {...userCompany}
      data={userCompany}
      saving={saving}
      visible={!!userCompany}
      uploading={uploading}
      title="Meus dados (NFS-e)"
    />
  );
};

export default ResourceEdit.create(CompanyEdit, {
  resource: 'users',
  currentAttr: 'userCompany',
  unloadOnUnmount: false
});
